export default __webpack_public_path__ + "static/media/ucl.a5b688c6.png";